import { useEffect, useRef } from "react";
import { useAuth } from "../AuthContext";

import { askForPermissionAndGetToken, onMessageListener } from "../firebase.js";

export const useFCM = (onMessage) => {
    const onMessageRef = useRef(onMessage);
    const { auth } = useAuth();

    useEffect(() => { onMessageRef.current = onMessage; }, [ onMessage ]);

    useEffect(() => {
        const tokenFetch = async () => {
            if (auth?.currentUser) {
                const token = await askForPermissionAndGetToken(process.env.REACT_APP_FCM_VAPID_KEY);

                if (!token) {
                    console.error("FCM: No registration token available.");
                }
            }
        };

        tokenFetch();

        const unsubscribe = onMessageListener((payload) => {
            onMessageRef.current(payload);
        });
        
        return () => { if (typeof unsubscribe === "function") { unsubscribe(); } };
    }, [ auth?.currentUser ]);
};